import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";
import { HighlightDay } from "../components/CustomCalendarTimeKeeping/ServerDay";
import moment from "moment";

interface InitialState {
  status?: ReduxStateType;
  month: number;
  year: number;
  data?: {
    [key: string]: HighlightDay[];
  };
}

const initialState: InitialState = {
  status: ReduxStateType.LOADING,
  month: moment().month() + 1,
  year: moment().year(),
  data: {},
};

const getListInternalDocsSlice = createSlice({
  name: "getTimeKeeping",
  initialState,
  reducers: {
    setMonthYearTimeChecking: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getTimeCheckingStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getTimeCheckingSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.data;
    },
    getTimeCheckingFailed: (state, action) => {
      state = {
        ...initialState,
        status: ReduxStateType.ERROR,
      };
    },
  },
});

export const {
  getTimeCheckingStart,
  getTimeCheckingSuccess,
  getTimeCheckingFailed,
  setMonthYearTimeChecking,
} = getListInternalDocsSlice.actions;

export default getListInternalDocsSlice.reducer;
